export default __webpack_public_path__ + "static/media/wallet-card-theme9.4e57c9ed.svg";